<!-- INVALID ACCESS PERMISSION -->
<div *ngIf="!validToken" class="flex flex-column align-items-center justify-content-center mt-5">
	<div class="flex bg-red-200 p-1 border-round-xl w-full flex-column text-center">
		<p-tag [value]="('INVALID_PERMISSION' | translate)" severity="danger" styleClass="text-lg"></p-tag>
		<p-tag [value]="('INVALID_PERMISSION_REASON' | translate)" severity="danger" styleClass="text-lg"></p-tag>
	</div>
</div>

<!-- PINPAD -->
<div *ngIf="!validPin && validToken && !resetPin">
	<app-pin-pad (pinConfirmed)="onPinInserted($event)"></app-pin-pad>
</div>

<!-- ACCESS PAGE AFTER VALID PIN INSERT -->
<div *ngIf="validPin && !resetPin" class="flex flex-column align-items-center justify-content-center mt-5" >
	<!-- VALIDITY PERMISSION -->
	<div class="flex bg-green-200 p-1 border-round-xl w-full"
		[class]="!onExtendedMobile() ? 'flex-row justify-content-center' : 'flex-column text-center'">
		<p-tag [value]="('PIN_VALIDITY' | translate)" severity="success"
			[styleClass]="!onExtendedMobile() ? 'pr-0 text-lg' : 'text-lg'"></p-tag>
		<p-tag *ngIf="accessPermission !== undefined && accessPermission.End !== undefined"
			[value]="(accessPermission.End | localizedDate: 'mediumDate':(accessPermission.Tz || 'UTC')) + ' ' + (accessPermission.End | localizedDate: 'shortTime':(accessPermission.Tz || 'UTC')) + (accessPermission.Tz ? ' (' + accessPermission.Tz + ')' : 'UTC')"
			severity="success"
			[styleClass]="!onExtendedMobile() ? ' text-lg' : 'text-lg'"></p-tag>
	</div>

	<!-- COMMANDS ACCESS -->
	<div *ngIf="accessPermission !== undefined" class="flex flex-column justify-content-center mt-5">
		<p-panel *ngFor="let automation of automationList | keyvalue" class="w-full"
			styleClass="mb-3">
			<ng-template pTemplate="header">
				<div class="flex align-items-center font-semibold gap-2">
					<!-- <div class="pi cm-devices"></div> -->
					{{ automation.key }}
				</div>
			</ng-template>
			<div class="grid m-0 flex align-items-center justify-content-center">
				<div *ngFor="let cmd of automation.value" [class]="this.onExtendedMobile() ? 'col-12 pb-0' : columnNumber">
					<button type="button" pButton pRipple id="buttonQuickEasyDeviceCommand-{{cmd.CommandDescription}}"
						[disabled]="!validPin" label="{{ cmd.CommandDescription }}" class="p-button-primary text-lg font-normal w-full"
						(click)="sendCommand(cmd)">
					</button>
				</div>
			</div>
		</p-panel>
	</div>
</div>

<!-- THS ACCESS -->
<div *ngIf="validPin && !resetPin && accessPermission !== undefined && permittedAccessThs !== undefined" class="flex align-items-center justify-content-center grid m-0 mb-3">
	<p-panel *ngFor="let th of permittedAccessThs" class="grid mt-0 col-12 flex justify-content-center">
		<ng-template pTemplate="header">
			<div class="flex align-items-center font-semibold gap-2">
				<div class="pi cm-termo"></div>
				{{ th.DeviceName }}
			</div>
		</ng-template>
		<div *ngIf="!getStatusThermoOnlineBnBQnE(th)" class="col-12 p-0">
			<div class="flex align-items-center justify-content-center bg-yellow-200 p-1 border-round-xl w-full flex-row">
				<div class="pi cm-alert text-yellow-700 pl-3"></div>
				<p-tag [value]="getStatusThermoString(th)" severity="warning" styleClass="text-lg"></p-tag>
			</div>
		</div>
		<div *ngIf="getStatusThermoOnlineBnBQnE(th)" class="flex flex-column align-items-center justify-content-center mt-0">
			<!-- TEMP & THERMO CONTROLS SEASONS -->
			<app-thermo-realtime-temp-info class="col-12" [thermoInput]="th" [camelCaseFormat]="true"></app-thermo-realtime-temp-info>

			<!-- DIVIDER -->
			<div class="col-12">
				<div class="flex border-bottom-2 text-100 py-0 mx-3"></div>
			</div>

			<!-- BNB_THERMAL_CONTROL (off, manual) -->
			<div class="grid m-0">
				<div class="col-12 pb-4">
					<!-- <div class="flex align-items-center justify-content-center text-lg">
						{{ 'THERMAL_CONTROL_B&B' | translate }}
					</div> -->
					<div class="flex flex-row align-items-center justify-content-center">
						<p-selectButton [options]="bnbThermalControlOptions" [(ngModel)]="th.Mode" optionValue="value"
							(onChange)="bnbThermalControlChanged(th)" optionDisabled="disabled">
							<ng-template let-item pTemplate>
								<div class="flex align-items-center justify-content-center gap-2"
									[class]="!onExtendedMobile() ? 'w-10rem' : ''">
									<i [class]="item.icon"></i>
									<span>{{item.name}}</span>
								</div>
							</ng-template>
						</p-selectButton>
					</div>
				</div>
			</div>
			<app-thermo-bnb-manual-control [thermoInput]="th" [camelCaseFormat]="true"
				(tempChange)="sliderTempStop($event, th)">
			</app-thermo-bnb-manual-control>
		</div>
	</p-panel>
</div>